import React from "react";
import { Plan } from "../../../@types";
import { PlanDetailSection, PlanContact } from "../../../components";
import { useTranslate } from "../../../helpers";

const DocumentsAndContact: React.FunctionComponent<{ plan: Plan }> = ({
  plan,
}) => {
  const t = useTranslate();

  return (
    <>
      <PlanDetailSection
        title={t("plan_terms.documents_and_contact_information")}
      >
        <PlanContact plan={plan} />
      </PlanDetailSection>
    </>
  );
};

export default DocumentsAndContact;
